import React from "react";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./Footer.scss";

const Footer = () => {
  const {t} = useTranslation()
  return (
    <div className="footer">
      {/* <Row>
        <Col xs={12} lg={5}>
          <div>
            <img alt="" src="/images/ch2.png" height={80} width={176}/>
          </div>
          <div className="mt-3">
            <h6 style={{ fontSize: 13 }}>
              {t("start_trading_bots")}
            </h6>
          </div>
          <Row className="mt-3 mr-0 mr-lg-5" noGutters>
            
          </Row>
        </Col>
        <Col xs={12} lg={7} className="mt-5 mt-lg-0">
          <Row>
            <Col>
              <ul>
                <li className="title">{t("platform")}</li>
                <li>
                  <a href="https://forexhero.ai/about" aria-label="About page">{t("About")}</a>
                </li>
                <li>
                  <a href="https://forexhero.ai/pricing" aria-label="Pricing page Link">{t("pricing")}</a>
                </li>
                <li>
                  <a href="https://blog.forexhero.ai" aria-label="Blog Link">{t("blog")}</a>
                </li>
                <li>
                  <a href="https://docs.forexhero.ai/" aria-label="User Guide Link">
                  {t("userguide")}
                  </a>
                </li>
                <li>
                  <a href="https://app.forexhero.ai/" aria-label="Login Link">{t("login")}</a>
                </li>
              </ul>
            </Col>
            <Col>
              <ul>
                <li className="title">{t("features")}</li>
                <li>
                  <a href="https://forexhero.ai/features/#automated-trading" aria-label="Featuers Link">
                    {t("auto-t")}
                  </a>
                </li>
                <li>
                  <a href="https://forexhero.ai/features/#technical-indicators" aria-label="Technical indicators Link">
                    {t("tech-ind")}
                  </a>
                </li>
              </ul>
            </Col>
            <Col>
              <ul>
                <li className="title">{t("Legal")}</li>
                <li>
                  <a href=" https://www.forexhero.ai/privacy.html" aria-label="Legal">
                    {t("priv-pol")}
                  </a>
                </li>
                <li>
                  <a href="https://www.forexhero.ai/terms.html" aria-label="Terms link">
                    {t("terms")}
                  </a>
                </li>
                <li>
                  <a href="mailto:admin@forexhero.ai" aria-label="Contact Us">{t("contact-us")}</a>
                </li>
              </ul>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="justify-content-center mt-5 copyright">
        {t("all-rights-reserved")}
      </Row> */}
    </div>
  );
};

export default Footer;
